import '@repo/tailwind-config/global.css'
import '@repo/ui/lang'
import './styles.css'

import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import { App } from '@/App.tsx'
import { ExceptionTracker } from '@/components/ExceptionTracker.tsx'
import { LocalStorageAccessTokenManager } from '@/external/access-token-manager.ts'
import { AxiosAPI } from '@/external/api/api.ts'
import { SocketIO } from '@/external/socket.ts'
import { StaticSocket } from '@/external/static-socket'
import { LoggerTracker } from '@/external/tracker/logger.ts'
import { PostHogTracker } from '@/external/tracker/posthog.ts'
import { buildApi as buildAltApi } from '@/services/api'
import { createStore } from '@/store'

export const api = new AxiosAPI(import.meta.env.VITE_API_URL as string).api()
export const altApi = buildAltApi({ baseURL: import.meta.env.VITE_API_URL as string })
export const accessTokenManager = new LocalStorageAccessTokenManager()
const postHogTracker = import.meta.env.VITE_PUBLIC_POSTHOG_KEY ? new PostHogTracker() : undefined

const store = createStore({
  accessTokenManager,
  sudoApi: api.sudo,
  api,
  altApi,
  socket: SocketIO.getInstance(),
  staticSocket: new StaticSocket(),
  tracker: import.meta.env.VITE_PUBLIC_POSTHOG_KEY ? postHogTracker! : new LoggerTracker(),
})
export type AppDispatch = typeof store.dispatch

// Only mount the app if we're not in Storybook
// This prevents the "Target container is not a DOM element" error in Storybook
if (!globalThis.IS_STORYBOOK) {
  const rootElement = document.getElementById('root')
  if (rootElement) {
    ReactDOM.createRoot(rootElement).render(
      <StrictMode>
        <ExceptionTracker client={postHogTracker?.client}>
          <Provider store={store}>
            <App />
          </Provider>
        </ExceptionTracker>
      </StrictMode>,
    )
  }
}
